import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../VerifyOTP/VerifyOTP.css";

const VerifyOTP = () => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const inputsRef = useRef([]);
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;

    const handleChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            inputsRef.current[index + 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").slice(0, 6);
        if (!/^\d{1,6}$/.test(pasteData)) return;

        const newOtp = pasteData.split("").concat(new Array(6 - pasteData.length).fill(""));
        setOtp(newOtp);
        inputsRef.current[pasteData.length - 1]?.focus();
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    const handleVerifyOTP = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage("");
        setError("");

        try {
            const response = await fetch("https://api.hgcdental.clinic/verify-otp", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, otp: otp.join("") }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.message || "Invalid OTP. Please try again.");
            } else {
                setMessage("OTP verified successfully!");
                setTimeout(() => {
                    navigate("/reset-password", { state: { email } });
                }, 1000);
            }
        } catch (error) {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleResendCode = async () => {
        setResendLoading(true);
        setMessage("");
        setError("");

        if (!email) {
            setError("Email not found. Please try again.");
            setResendLoading(false);
            return;
        }

        try {
            const response = await fetch("https://api.hgcdental.clinic/resend-otp", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.message || "Failed to resend OTP.");
            } else {
                setMessage("A new OTP has been sent to your email.");
            }
        } catch (error) {
            setError("An error occurred while resending the OTP.");
        } finally {
            setResendLoading(false);
        }
    };

    // 🔹 New function: Handle Cancel button
    const handleCancel = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <div className="verify-container">
            <div className="verify-box">
                <h2 className="verify-title">Verify OTP</h2>
                <p className="verify-text">Enter the 6-digit code sent to your email</p>

                {error && <div className="error-message">{error}</div>}
                {message && <div className="success-message">{message}</div>}

                <form onSubmit={handleVerifyOTP}>
                    <div className="code-inputs">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputsRef.current[index] = el)}
                                type="text"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                onPaste={handlePaste}
                            />
                        ))}
                    </div>

                    <button type="submit" className="verify-button" disabled={loading}>
                        {loading ? "Verifying..." : "Verify OTP"}
                    </button>

                    {/* Cancel Button */}
                    <button type="button" className="verify-cancel-button" onClick={handleCancel}>
                        Cancel
                    </button>
                </form>

                <p className="resend-text">
                    Didn't get the code?{" "}
                    <button className="resend-button" onClick={handleResendCode} disabled={resendLoading}>
                        {resendLoading ? "Resending..." : "Resend"}
                    </button>
                </p>
            </div>
        </div>
    );
};

export default VerifyOTP;
